import ManageScenario from './ManageScenario';

export default ManageScenario;
